import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const adminCreateAction=createAsyncThunk(
    'admin/create',async(reqBody,thunkAPI)=>{
        try {
            const response = await Api.post('school/admin/create',reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

    export const adminListAction=createAsyncThunk(
        'admin/list',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.get(`school/admin/list`)
               
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })


        


        export const adminChangeRoleAction=createAsyncThunk(
            'admin/changeRole',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.put(`school/admin/switchToTeacher`,reqBody)
                   
                    return response.data  
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })



        export const adminDetailAction=createAsyncThunk(
            'admin/details',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.get(`school/admin/details?id=${reqBody}`)
                   
                    return response.data  
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })

            export const adminDeleteAction=createAsyncThunk(
                'admin/delete',async(reqBody,thunkAPI)=>{
                    try {
                        const response = await Api.delete(`school/admin/delete?id=${reqBody}`)
                       
                        return response.data  
                    } catch (error) {
                        return thunkAPI.rejectWithValue(error.response.data);
                    }
                })

               export const adminEditProfileSettingsAction=createAsyncThunk(
                            'teacher/editadminProfile',async(reqBody,thunkAPI)=>{
                                try {
                                    const response = await Api.put(`school/admin/edit`,reqBody)
                                   
                                    return response.data  
                                } catch (error) {
                                    return thunkAPI.rejectWithValue(error.response.data);
                                }
                            })
    


                export const adminEditAction=createAsyncThunk(
                    'admin/edit',async(reqBody,thunkAPI)=>{
                        try {
                            const response = await Api.put(`school/admin/edit`,reqBody)
                           
                            return response.data  
                        } catch (error) {
                            return thunkAPI.rejectWithValue(error.response.data);
                        }
                    })
               


             export const resetadminAction = createAction('browse/reset');


                   


        